import React from 'react';
import { useSelector, useDispatch } from 'react-redux'
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';

import { postGetCities } from '../serviceAPI/getCities'

export default function CidadeForm(props) {
    const recuperarCidade = props.recuperarCidade
    const dispatch = useDispatch();

    const ufRecuperada = useSelector(state => state.cidades.uf)
    const cidadeIdRecuperada = useSelector(state => state.cidades.cidadeId)
    const cidades = useSelector(state => state.cidades.cidades)

    const [uf, setUf] = React.useState('');
    const [cidadeId, setCidadeId] = React.useState('');

    React.useEffect(() => {
        if (recuperarCidade) {
            firstRequest();
        } else {
            dispatch({
                type: 'CLEAR_CIDADES',
            })
        }

        async function firstRequest() {
            if (ufRecuperada !== "") {
                await buscarCidades(ufRecuperada)
            }
        }
    }, [])

    React.useEffect(() => {
        selecionarCidade(cidadeIdRecuperada)
    }, [cidades]);

    async function buscarCidades(value) {
        setUf(value)
        if (value !== "") {
            await postGetCities(value, dispatch)
        } else {
            dispatch({
                type: 'CLEAR_CIDADES',
            })
        }
    }

    const selecionarCidade = (value) => {
        const code = value
        setCidadeId(code)
        const cidadeSelecionada = cidades.find((cidade) => (cidade.code == code))
        dispatch({
            type: 'SET_CIDADE_SELECIONADA',
            cidadeSelecionada: cidadeSelecionada
        })
        dispatch({
            type: 'SET_UF',
            uf: uf
        })
    };

    return (
        <Grid container spacing={1}>
            <Grid item xs={3}>
                <FormControl required fullWidth variant="outlined">
                    <InputLabel id="labelUF">UF</InputLabel>
                    <Select
                        native
                        fullWidth
                        labelId="labelUF"
                        id="uf"
                        label="UF"
                        value={uf}
                        onChange={(e) => buscarCidades(e.target.value)}
                    >
                        <option value=''></option>
                        <option value='AC'>AC</option>
                        <option value='AL'>AL</option>
                        <option value='AM'>AM</option>
                        <option value='AP'>AP</option>
                        <option value='BA'>BA</option>
                        <option value='CE'>CE</option>
                        <option value='DF'>DF</option>
                        <option value='ES'>ES</option>
                        <option value='GO'>GO</option>
                        <option value='MA'>MA</option>
                        <option value='MG'>MG</option>
                        <option value='MS'>MS</option>
                        <option value='MT'>MT</option>
                        <option value='PA'>PA</option>
                        <option value='PB'>PB</option>
                        <option value='PE'>PE</option>
                        <option value='PI'>PI</option>
                        <option value='PR'>PR</option>
                        <option value='RJ'>RJ</option>
                        <option value='RN'>RN</option>
                        <option value='RO'>RO</option>
                        <option value='RR'>RR</option>
                        <option value='RS'>RS</option>
                        <option value='SC'>SC</option>
                        <option value='SE'>SE</option>
                        <option value='SP'>SP</option>
                        <option value='TO'>TO</option>
                    </Select>
                </FormControl>
            </Grid>

            <Grid item xs={9}>
                <FormControl required fullWidth variant="outlined">
                    {recuperarCidade ?
                        null
                        :
                        <InputLabel id="labelCidade">Cidade</InputLabel>
                    }
                    <Select
                        value={cidadeId}
                        onChange={(event) => selecionarCidade(event.target.value)}
                        native
                        id="cidade"
                        label="Cidade"
                        labelId="labelCidade"
                    >
                        <option value=''></option>
                        {cidades.map((cidade) => {
                            return <option key={cidade.code} value={cidade.code}>{cidade.name}</option>
                        })}
                    </Select>
                </FormControl>
            </Grid>
        </Grid>
    );
}